// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"jut__DropdownMenuButton__fullWidth"};